<mat-form-field
  subscriptSizing="dynamic"
  class="w-full">
  <mat-icon
    matPrefix
    class="icon-sm"
    svgIcon="remix:System/search-line" />
  <input
    matInput
    type="search"
    [formControl]="formControl"
    [placeholder]="placeholder | translate"
    [attr.aria-label]="(ariaLabel || placeholder) | translate"
    (blur)="onTouched?.()" />
</mat-form-field>
